export class JobsStrings {
  static introTitle = 'Monitor all your Pipelines in one place';

  static introDescription =
    'There is nothing to see here yet. Create a Pipeline to start monitoring the flow of data from your Source to the Destination.';

  static cancelJobSuccessMessage = 'Request to cancel Job has been successfully registered.';
}
